import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles(() => ({
  previewDataTable: {
    padding: 20,
    marginTop: 45,
  },

  tableContainer: {
    overflow: 'auto',
    position: 'relative',
    height: 450,
    backgroundColor: themesConfig.default.colors['grey-50'],

    '& thead, td, th': {
      backgroundColor: `${themesConfig.default.colors['grey-50']} !important `,
    },

    '& td': {
      padding: 10,
      height: 56,
    },

    '& tr': {
      borderBottom: `1px solid ${themesConfig.default.colors['light-grayish-blue']}`,
    },
  },

  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },

  fileNameWrapp: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },

  fileName: {
    color: themesConfig.default.colors.black,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '24px',
  },

  deleteBtn: {
    color: themesConfig.default.colors['red-700'],
    fontSize: 16,
    lineHeight: '24px',
    cursor: 'pointer',
  },

  actionButtonsWrapp: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 42,
  },

  tableWrapp: {
    maxHeight: 450,
    minHeight: 400,
    overflowY: 'auto',
  },
}))
